export default __webpack_public_path__ + "assets/logo.3a5f6fe4.svg";